/**
 * React Query Client Configuration
 */

import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './client';

/**
 * Create a configured QueryClient instance
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // Data is considered fresh for 30 seconds
        staleTime: 30 * 1000,
        // Keep unused data in cache for 5 minutes
        gcTime: 5 * 60 * 1000,
        // Retry failed requests up to 3 times
        retry: (failureCount, error) => {
          // Don't retry on auth errors
          if (error instanceof ApiError && error.status === 401) {
            return false;
          }
          // Don't retry on not found
          if (error instanceof ApiError && error.status === 404) {
            return false;
          }
          // Retry up to 3 times for other errors
          return failureCount < 3;
        },
        // Retry with exponential backoff
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      },
      mutations: {
        // Don't retry mutations by default
        retry: false,
      },
    },
  });
}

/**
 * Singleton query client for the application
 */
export const queryClient = createQueryClient();
